import React from 'react'
import styles from '../../styles/products.module.css';

interface ProductDeliveryRobotCaseItemProps {
    title: string;
    title2?: string;
    icon: string;
}


const ProductDeliveryRobotCaseItem: React.FC<ProductDeliveryRobotCaseItemProps> = ({ icon, title, title2 }) => {
    return (
        <div className={styles.caseDelivery}>
            <div className={styles.iconBox}>
                <img src={icon} alt="icon" />
            </div>
            <div className={styles.caseDeliveryText}>
                <div>{title}</div>
                {title2 ?
                    <div>{title2}</div>
                    : null
                }
            </div>
        </div>

    )
}

export default ProductDeliveryRobotCaseItem;